import React from 'react';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import styled from 'styled-components';
import {TopElevenCard} from 'app/components/topEleven/TopElevenCard';
import {InfoCard} from 'app/components/infoCard/InfoCard';
import {Footer} from 'app/components/Footer';
import {data} from 'app/components/data';
import {HeroImage} from 'app/components/HeroImage';
import {SubstitutesCard} from 'app/components/topEleven/SubstitutesCard';
import InfoCardEmbed from 'app/components/infoCard/InfoCardEmbed';

const Content = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Card = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 32.25rem;
  flex-wrap: wrap;
  border: 1px solid ${COLORS.black};
  padding: ${SIZES['16']};
  @media only screen and (max-width: 600px) {
    padding: ${SIZES['16']} 0;
  }
  @media only screen and (min-width: 64.5rem) {
    max-width: 64.5rem;
  }
  @media only screen and (min-width: 72.375rem) {
    max-width: 72.375rem;
  }
`;

const StyledCard = styled(Card)`
  flex-direction: column;
  align-items: center;
`;

const CardsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${SIZES['32']} ${SIZES['64']};
  width: 100%;
  padding: ${SIZES['64']} ${SIZES['8']} ${(props) => (props.noPaddingBottom ? '0' : SIZES['64'])};
`;

const StyledTypography = styled(Typography)`
  &&& {
    font-weight: 700;
  }
`;

const Link = styled.a`
  color: inherit;
`;

const AppShell = () => {
  return (
    <React.Fragment>
      <Content>
        <HeroImage
          basicName={data.mainHeader.image.basicName}
          basicRoute={data.mainHeader.image.basicRoute}
          altText={data.mainHeader.image.alt}
        />
        <CardsWrapper noPaddingBottom={true}>
          <StyledCard>
            <StyledTypography variant='headline'>{data.informationBanner}</StyledTypography>
            <StyledTypography variant='headline'>
              <Link href={data.link} target='_blank'>
                Zum Spiel auf FuPa
              </Link>
            </StyledTypography>
          </StyledCard>
        </CardsWrapper>
        <CardsWrapper>
          <Card>
            <TopElevenCard topElevenId={1} topElevenTexts={data.topEleven1} />
            <TopElevenCard topElevenId={2} topElevenTexts={data.topEleven2} />
            <SubstitutesCard id={3} texts={data.substitutes} />
          </Card>
        </CardsWrapper>
        <HeroImage
          basicName={data.bottomHeader.image.basicName}
          basicRoute={data.bottomHeader.image.basicRoute}
          altText={data.bottomHeader.image.alt}
        />
        <CardsWrapper>
          <InfoCard data={data.infoCard1} />
          <InfoCard data={data.infoCard2} />
          <InfoCardEmbed />
        </CardsWrapper>
      </Content>
      <Footer />
    </React.Fragment>
  );
};

export {AppShell};
